<template>
  <div class="container-full index-font">
    <div class="container ">
      <h1>{{res.title}}</h1>
      <p>{{res.about}} </p>
    </div>
  </div>
</template>
<script>
export default {
   props: ["res"],
  components: {}
};
</script>
<style lang="less" scoped>
.index-font {
  background-color: #ffffff;
  .container {
    // border-bottom: 2px dotted #dcdcdc;
  }

  text-align: center;
  h1 {
    font-size: 48px;
    font-weight: 600;
    line-height: 26px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-top: 120px;
    margin-bottom: 60px;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 29px;
    color: rgba(0, 0, 0, 1);
    text-align: justify;
    padding-bottom: 60px;
    white-space: pre-line;
  }
}
@media (max-width: 765px) {
  .index-font {
    text-align: center;
    padding:0   15px;
    h1 {
       margin-top: 50px;
      margin-bottom: 15px;
      font-size: 24px;
    }
    p {
    font-size: 12px;
    line-height: 18px;
    color: #222222;
    text-align: justify;
    padding-bottom: 15px;
  }
  }
}
</style>